module.exports = __webpack_public_path__ + "static/img/3.6cccb87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/3.jpg
// module id = +qmf
// module chunks = 16